export function Who() {
  return (
    <section className="section" id="who">
      <h2>Who this is for</h2>
      <div className="cols">
        <div>
          <h3>Protocols and lending markets</h3>
          <p>Ask the verifier before you list, pair or lend against a Stock Token, inside the same transaction. It has no owner and no list to go stale: a token the issuer deploys tomorrow passes on the day it exists. It proves the token came from the issuer's factory; it does not assess backing or redemption. Free, ownerless, MIT.</p>
        </div>
        <div>
          <h3>Liquidity providers</h3>
          <p>In a bell hook pool the fee follows the gap you are exposed to, not the calendar. It sits at the pool's normal fee tier while the feed is fresh, rises as the pool drifts from the frozen feed, and returns to base when the feed moves again. All of it is yours; there is no protocol cut. The curve's parameters change through BellConfig's 24 hour timelock, so a change is visible a day before it applies.</p>
        </div>
        <div>
          <h3>Builders</h3>
          <p>One view function, one hook, one API. The verify and quote tools below call the worker API, which reads the deployed contracts; the checker asks the deployed verifier the same question your contract would, from your browser, and gives you the cast line to repeat it.</p>
        </div>
      </div>
    </section>
  );
}
